export default "__VITE_PUBLIC_ASSET__8426d307__"